// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbs-wrapper {
  margin-top: 20px;
}

.thumbs {
  margin-top: 10px;
}

.image-container {
  position: relative;       /* Para que los elementos con position: absolute se ubiquen respecto a este contenedor */
  display: inline-block;    /* Hace que el contenedor se ajuste al tamaño del contenido */
  margin: 0 auto;           /* Centra el contenedor horizontalmente */
  text-align: center;       /* Opcional, si se requiere centrar también el texto */
}
.image-container img {
  display: block;           /* Evita espacios en línea */
  max-height: 400px;        /* Según tu estilo */
  width: auto;
}

.thumbs .thumb {
  width: 80px;
  /* Cambia este valor al ancho deseado para las miniaturas */
  height: 80px;
  /* Cambia este valor al alto deseado para las miniaturas */
  display: inline-block;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}

.thumbs .thumb.selected,
.thumbs .thumb:hover {
  border: 2px solid #333;
}

.thumbs .thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.custom-carousel .legend {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  font-size: 16px;
  display: none;
  /* Hide the legend by default */
  position: absolute;
  /* Position the legend relative to the photo */
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  /* Set a higher z-index than the photo to ensure the legend is on top */
}

.custom-carousel:hover .legend {
  display: block;
  /* Show the legend when hovering over the photo */
}


/* Estilos box alert informacion adicional */
.alert {
  padding: 20px;
  background-color: #2196F3;
  color: white;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.alert p {
  margin-bottom: 0px;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.custom-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  z-index: 1;
  /* Para asegurar que estén sobre las imágenes */
}

.custom-arrow.prev {
  left: 10px;
  /* Ajustar la posición de la flecha previa */
}

.custom-arrow.next {
  right: 10px;
  /* Ajustar la posición de la flecha siguiente */
}

/* Manejo de thumbnails video gallery  */
.thumbnails {
  display: flex;
  overflow-x: auto;
}

.thumbnail {
  cursor: pointer;
  margin-right: 10px;
}

.thumbnail video {
  max-width: 50px;
}

.thumbnail.selected video {
  border: 2px solid black;
  /* Ajusta el estilo según lo necesites */
}

/* Boton close */
.btnClose {
  display: flex;
  flex-direction: row;
}

#ModalGaleria .sweet-alert-popup {
  z-index: 1051;
  /* Ajusta el z-index según sea necesario para que esté por encima del modal */
}

/* Accordion body 
Mostrar info de OCR
accordion-body
accordion-button */
.accordion-body {
  padding: 0;
  margin: 0;


}

.accordion-body ul {
  padding-left: 0rem;
}

.accordion-button {
  padding: 2px;
  margin-bottom: 0;
  background-color: #1769aa;
  color: aliceblue;
}

.accordion-button.active {
  background-color: #1769aa;
  /* Optional: Change the background when expanded */
  color: aliceblue;
}

.word_content {
  padding-left: 10px;
  background: #D4E1FF;
  color: black;
  list-style: none;
  cursor: pointer;
  justify-content: start;
}

.attribute_name {
  padding-left: 10px;
  background: #D4E1FF;
  color: black;
  list-style: none;
  cursor: pointer;
}

.attribute_class {
  /* padding-left: 10px; */
  /* background: #6ABFF4; */
  color: black;
  list-style: none;
  cursor: pointer;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  

}

.attribute_class .container_span_iconName{
  display: flex;
  color: white;
  background: #1769aa;
  
}

.attribute_class span {
  padding-left: 4px;
}

.attribute_class ul {
  padding-left: 0rem;
  font-weight: 400;
}

.attribute_content {
  padding-left: 10px;
  list-style: none;
  background: white;
  color: black;
}

.accordion-body ul {
  margin-bottom: 0;

}

.content_content {
  background: #6ABFF4;
  color: black;
  list-style: none;
  cursor: pointer;
  font-weight: 500;
}

.contenido_content {
  padding-left: 15px;
  margin-bottom: 0;

}

.color_name_attribute{
  color: white;
  background: #1769aa;
  padding: 2px;
}


/* Backdrop styles en enfoque */
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Color oscuro con transparencia */
  z-index: 9999;
  /* Asegura que esté por encima de todos los demás elementos */
}
.video-gallery-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
}

.video-gallery-modern {
  width: 100%;
}

.video-gallery-alert-row {
  margin-bottom: 10px;
}

.video-gallery-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1b84c5 0%, #2ea4b1 100%);
  color: #fff;
}

.video-gallery-alert p {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 500;
}

.video-gallery-layout {
  --bs-gutter-x: 14px;
}

.video-gallery-main {
  margin-bottom: 0 !important;
}

.video-gallery-player-card {
  background: linear-gradient(180deg, #071b2a 0%, #041522 100%);
  border-radius: 14px;
  border: 1px solid #0e2f45;
  overflow: hidden;
  padding: 10px;
  box-shadow: inset 0 0 0 1px rgba(71, 167, 245, 0.15);
}

.video-gallery-slide {
  background: linear-gradient(135deg, #02172a 0%, #072742 100%);
  border: 1px solid rgba(71, 167, 245, 0.4);
  border-radius: 12px;
  overflow: hidden;
}

.video-gallery-player {
  max-width: 100%;
}

.video-gallery-empty-main {
  min-height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a8c4dd;
  background: linear-gradient(135deg, #031629 0%, #082f50 100%);
}

.video-gallery-empty-card {
  text-align: center;
  max-width: 460px;
  padding: 24px 20px;
}

.video-gallery-empty-icon {
  color: #4fb5ff;
  font-size: 28px;
  line-height: 1;
  margin-bottom: 10px;
}

.video-gallery-empty-card h4 {
  color: #9fc7e8;
  margin: 0 0 8px;
  font-size: 2rem;
  font-weight: 700;
}

.video-gallery-empty-card p {
  margin: 0;
  color: #b7d6ee;
  font-size: 1.05rem;
}

.video-gallery-thumbnails-card {
  margin-top: 14px;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #10314a;
  background: linear-gradient(180deg, #041522 0%, #051a2b 100%);
}

.thumbnails {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.video-thumb {
  flex: 0 0 88px;
  width: 88px;
  height: 70px;
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid transparent;
  background: #0f172a;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease;
}

.video-thumb:hover {
  transform: translateY(-2px);
  border-color: #1b84c5;
}

.video-thumb video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-thumb.selected {
  border-color: #2ea4b1;
}

.video-gallery-empty-thumbs {
  color: #87a5bf;
  margin: 2px 4px 0;
}

.video-gallery-side {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
}

.video-gallery-side-title {
  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
  color: #fff;
  width: 100%;
  text-align: center;
  margin: 0;
  border-radius: 10px 10px 0 0;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
}

.video-gallery-panel-content {
  padding: 10px;
  border: 1px solid #d3e1ef;
  border-top: 0;
  color: #0f172a;
  border-radius: 0 0 10px 10px;
  background: #f9fcff;
  min-height: 125px;
}

.video-gallery-panel-content-scroll {
  min-height: 260px;
  max-height: 320px;
  overflow: auto;
}

.video-gallery-reload {
  width: 18px;
  cursor: pointer;
}

@media (max-width: 992px) {
  .video-gallery-player-card {
    margin-bottom: 8px;
  }

  .video-gallery-side {
    margin-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/carousel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB,QAAQ,wFAAwF;EAClH,qBAAqB,KAAK,6DAA6D;EACvF,cAAc,YAAY,yCAAyC;EACnE,kBAAkB,QAAQ,sDAAsD;AAClF;AACA;EACE,cAAc,YAAY,4BAA4B;EACtD,iBAAiB,SAAS,oBAAoB;EAC9C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,YAAY;EACZ,0DAA0D;EAC1D,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;EAC9C,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,uEAAuE;AACzE;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;;AAGA,4CAA4C;AAC5C;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,+CAA+C;AACjD;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6EAA6E;AAC/E;;AAEA;;;kBAGkB;AAClB;EACE,UAAU;EACV,SAAS;;;AAGX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;;;AAGxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;;AAGA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mCAAmC;EACnC,aAAa;EACb,6DAA6D;AAC/D;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,6DAA6D;EAC7D,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".thumbs-wrapper {\n  margin-top: 20px;\n}\n\n.thumbs {\n  margin-top: 10px;\n}\n\n.image-container {\n  position: relative;       /* Para que los elementos con position: absolute se ubiquen respecto a este contenedor */\n  display: inline-block;    /* Hace que el contenedor se ajuste al tamaño del contenido */\n  margin: 0 auto;           /* Centra el contenedor horizontalmente */\n  text-align: center;       /* Opcional, si se requiere centrar también el texto */\n}\n.image-container img {\n  display: block;           /* Evita espacios en línea */\n  max-height: 400px;        /* Según tu estilo */\n  width: auto;\n}\n\n.thumbs .thumb {\n  width: 80px;\n  /* Cambia este valor al ancho deseado para las miniaturas */\n  height: 80px;\n  /* Cambia este valor al alto deseado para las miniaturas */\n  display: inline-block;\n  margin-right: 5px;\n  overflow: hidden;\n  position: relative;\n}\n\n.thumbs .thumb.selected,\n.thumbs .thumb:hover {\n  border: 2px solid #333;\n}\n\n.thumbs .thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.custom-carousel .legend {\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 10px;\n  font-size: 16px;\n  display: none;\n  /* Hide the legend by default */\n  position: absolute;\n  /* Position the legend relative to the photo */\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  /* Set a higher z-index than the photo to ensure the legend is on top */\n}\n\n.custom-carousel:hover .legend {\n  display: block;\n  /* Show the legend when hovering over the photo */\n}\n\n\n/* Estilos box alert informacion adicional */\n.alert {\n  padding: 20px;\n  background-color: #2196F3;\n  color: white;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.alert p {\n  margin-bottom: 0px;\n}\n\n.closebtn {\n  margin-left: 15px;\n  color: white;\n  font-weight: bold;\n  float: right;\n  font-size: 22px;\n  line-height: 20px;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.closebtn:hover {\n  color: black;\n}\n\n.custom-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  z-index: 1;\n  /* Para asegurar que estén sobre las imágenes */\n}\n\n.custom-arrow.prev {\n  left: 10px;\n  /* Ajustar la posición de la flecha previa */\n}\n\n.custom-arrow.next {\n  right: 10px;\n  /* Ajustar la posición de la flecha siguiente */\n}\n\n/* Manejo de thumbnails video gallery  */\n.thumbnails {\n  display: flex;\n  overflow-x: auto;\n}\n\n.thumbnail {\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.thumbnail video {\n  max-width: 50px;\n}\n\n.thumbnail.selected video {\n  border: 2px solid black;\n  /* Ajusta el estilo según lo necesites */\n}\n\n/* Boton close */\n.btnClose {\n  display: flex;\n  flex-direction: row;\n}\n\n#ModalGaleria .sweet-alert-popup {\n  z-index: 1051;\n  /* Ajusta el z-index según sea necesario para que esté por encima del modal */\n}\n\n/* Accordion body \nMostrar info de OCR\naccordion-body\naccordion-button */\n.accordion-body {\n  padding: 0;\n  margin: 0;\n\n\n}\n\n.accordion-body ul {\n  padding-left: 0rem;\n}\n\n.accordion-button {\n  padding: 2px;\n  margin-bottom: 0;\n  background-color: #1769aa;\n  color: aliceblue;\n}\n\n.accordion-button.active {\n  background-color: #1769aa;\n  /* Optional: Change the background when expanded */\n  color: aliceblue;\n}\n\n.word_content {\n  padding-left: 10px;\n  background: #D4E1FF;\n  color: black;\n  list-style: none;\n  cursor: pointer;\n  justify-content: start;\n}\n\n.attribute_name {\n  padding-left: 10px;\n  background: #D4E1FF;\n  color: black;\n  list-style: none;\n  cursor: pointer;\n}\n\n.attribute_class {\n  /* padding-left: 10px; */\n  /* background: #6ABFF4; */\n  color: black;\n  list-style: none;\n  cursor: pointer;\n  font-weight: 700;\n  display: flex;\n  flex-direction: column;\n  \n\n}\n\n.attribute_class .container_span_iconName{\n  display: flex;\n  color: white;\n  background: #1769aa;\n  \n}\n\n.attribute_class span {\n  padding-left: 4px;\n}\n\n.attribute_class ul {\n  padding-left: 0rem;\n  font-weight: 400;\n}\n\n.attribute_content {\n  padding-left: 10px;\n  list-style: none;\n  background: white;\n  color: black;\n}\n\n.accordion-body ul {\n  margin-bottom: 0;\n\n}\n\n.content_content {\n  background: #6ABFF4;\n  color: black;\n  list-style: none;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.contenido_content {\n  padding-left: 15px;\n  margin-bottom: 0;\n\n}\n\n.color_name_attribute{\n  color: white;\n  background: #1769aa;\n  padding: 2px;\n}\n\n\n/* Backdrop styles en enfoque */\n.backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* Color oscuro con transparencia */\n  z-index: 9999;\n  /* Asegura que esté por encima de todos los demás elementos */\n}\n.video-gallery-modal-content {\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);\n}\n\n.video-gallery-modern {\n  width: 100%;\n}\n\n.video-gallery-alert-row {\n  margin-bottom: 10px;\n}\n\n.video-gallery-alert {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #1b84c5 0%, #2ea4b1 100%);\n  color: #fff;\n}\n\n.video-gallery-alert p {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.video-gallery-layout {\n  --bs-gutter-x: 14px;\n}\n\n.video-gallery-main {\n  margin-bottom: 0 !important;\n}\n\n.video-gallery-player-card {\n  background: linear-gradient(180deg, #071b2a 0%, #041522 100%);\n  border-radius: 14px;\n  border: 1px solid #0e2f45;\n  overflow: hidden;\n  padding: 10px;\n  box-shadow: inset 0 0 0 1px rgba(71, 167, 245, 0.15);\n}\n\n.video-gallery-slide {\n  background: linear-gradient(135deg, #02172a 0%, #072742 100%);\n  border: 1px solid rgba(71, 167, 245, 0.4);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.video-gallery-player {\n  max-width: 100%;\n}\n\n.video-gallery-empty-main {\n  min-height: 380px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #a8c4dd;\n  background: linear-gradient(135deg, #031629 0%, #082f50 100%);\n}\n\n.video-gallery-empty-card {\n  text-align: center;\n  max-width: 460px;\n  padding: 24px 20px;\n}\n\n.video-gallery-empty-icon {\n  color: #4fb5ff;\n  font-size: 28px;\n  line-height: 1;\n  margin-bottom: 10px;\n}\n\n.video-gallery-empty-card h4 {\n  color: #9fc7e8;\n  margin: 0 0 8px;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.video-gallery-empty-card p {\n  margin: 0;\n  color: #b7d6ee;\n  font-size: 1.05rem;\n}\n\n.video-gallery-thumbnails-card {\n  margin-top: 14px;\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px solid #10314a;\n  background: linear-gradient(180deg, #041522 0%, #051a2b 100%);\n}\n\n.thumbnails {\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n}\n\n.video-thumb {\n  flex: 0 0 88px;\n  width: 88px;\n  height: 70px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 2px solid transparent;\n  background: #0f172a;\n  cursor: pointer;\n  transition: transform 0.18s ease, border-color 0.18s ease;\n}\n\n.video-thumb:hover {\n  transform: translateY(-2px);\n  border-color: #1b84c5;\n}\n\n.video-thumb video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-thumb.selected {\n  border-color: #2ea4b1;\n}\n\n.video-gallery-empty-thumbs {\n  color: #87a5bf;\n  margin: 2px 4px 0;\n}\n\n.video-gallery-side {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n}\n\n.video-gallery-side-title {\n  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);\n  color: #fff;\n  width: 100%;\n  text-align: center;\n  margin: 0;\n  border-radius: 10px 10px 0 0;\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.video-gallery-panel-content {\n  padding: 10px;\n  border: 1px solid #d3e1ef;\n  border-top: 0;\n  color: #0f172a;\n  border-radius: 0 0 10px 10px;\n  background: #f9fcff;\n  min-height: 125px;\n}\n\n.video-gallery-panel-content-scroll {\n  min-height: 260px;\n  max-height: 320px;\n  overflow: auto;\n}\n\n.video-gallery-reload {\n  width: 18px;\n  cursor: pointer;\n}\n\n@media (max-width: 992px) {\n  .video-gallery-player-card {\n    margin-bottom: 8px;\n  }\n\n  .video-gallery-side {\n    margin-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
